// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2Iw7Y","title":"InfoRow_title__2P3IR"};